<a data-uat="betSlipBtn" class="menu-item user-bets" (click)="openBetslip()">
    <betslip-counter></betslip-counter>
    <span class="menu-text" [i18n]="'bma.betslip'"></span>
</a>
